<template>
  <el-dialog title="" :visible.sync="show" :before-close="close" destroy-on-close center>
    <el-form ref="applyForm" :model="applyInfo" label-width="40%" :rules="rules">
      <el-form-item label="证件类型" prop="paperType">
        <el-select v-model="applyInfo.paperType" placeholder="请选择"  :disabled="type !== 'new'" clearable filterable @change="handlePaperType">
          <el-option v-for="item in fileTypeList" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件" prop="paperName">
        <el-select v-model="applyInfo.paperName" placeholder="请选择证件" clearable :disabled="type === 'see'" filterable>
          <el-option v-for="item in certificatesList" :key="item.id" :label="item.paperName" :value="item.paperName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用途" prop="purpose">
        <el-input :disabled="type === 'see'" type="textarea" :rows="5" placeholder="请输入用途" maxlength="200"
          show-word-limit v-model="applyInfo.purpose" />
      </el-form-item>
      <el-form-item label="失效时间" prop="disableTime">
        <el-date-picker :disabled="type === 'see'" v-model="applyInfo.disableTime" type="datetime"
          :picker-options="pickeroptions" placeholder="请选择失效时间">
        </el-date-picker>
      </el-form-item>
      <template v-if="applyInfo.approvalFlag">
        <el-form-item label="审核状态" prop="status" :rules="{
          required: true, message: '请选择审核状态', trigger: 'change'
        }">
          <el-select v-model="applyInfo.status" @change="handleRemark">
            <el-option :value="item.value" :label="item.label"  v-for="(item,index) in statusOptions" :key="index"/>
          </el-select>
        </el-form-item>
        <el-form-item label="审核原因" >
          <el-input type="textarea" :rows="5" maxlength="200" show-word-limit placeholder="请输入审核原因"
            v-model="applyInfo.remark" @input="changeMessage($event)" />
        </el-form-item>
      </template>
      <template v-if="type === 'new' || applyInfo.status === 0">
            <approvalRadio  v-model="isSubmitApproval" v-show="type === 'new'"/>
            <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine'">
              <el-select v-model="applyInfo.auditPersonId" placeholder="请选择" clearable filterable :disabled="type !== 'new'">
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下一级审核人" prop="auditPersonId" v-else>
            <el-input v-model="this.applyInfo.auditPerson" disabled />
          </el-form-item>
        </template>
      <template v-if="activeName == 'queryMyAudit'">
              <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="applyInfo.status == '1'">
                <el-radio v-model="applyInfo.lastUserFlag" :label="1">是</el-radio>
                <el-radio v-model="applyInfo.lastUserFlag" :label="0">否</el-radio>
              </el-form-item>

              <approvalRadio  v-model="isSubmitApproval" v-show="applyInfo.status == '1' && applyInfo.lastUserFlag == 0"/>

              <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="applyInfo.status == '1' && applyInfo.lastUserFlag == 0">
                <el-select v-model="applyInfo.nextAuditUserName" placeholder="请选择" clearable filterable>
                  <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>

              <approvalRadio  v-model="isSubmitApproval" v-show="applyInfo.status == '3'"/>

              <el-form-item label="转办人" prop="nextAuditUserName" v-if="applyInfo.status == '3'">
                <el-select v-model="applyInfo.nextAuditUserName" placeholder="请选择" clearable filterable>
                  <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
      </template>
      <!-- <el-form-item label="下一级审核人" prop="auditPersonId" v-if="type === 'new' || !applyInfo.approvalFlag">
        <el-select v-model="applyInfo.auditPersonId" placeholder="请选择" clearable filterable :disabled="type === 'see'">
          <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="applyInfo.status == '1'">
        <el-radio v-model="applyInfo.lastUserFlag" :label="1">是</el-radio>
        <el-radio v-model="applyInfo.lastUserFlag" :label="0">否</el-radio>
      </el-form-item>
      <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="applyInfo.status == '1' && applyInfo.lastUserFlag == 0">
        <el-select v-model="applyInfo.nextAuditUserName" placeholder="请选择" clearable filterable>
          <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
          </el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <review-process :processList="applyInfo.auditProcessEntityList" :createTime="applyInfo.createTime"
      :createUser="applyInfo.applyUser" :auditPerson="applyInfo.auditPerson" />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="type === 'new'">提 交</el-button>
      <el-button type="primary" @click="addStagingForm()" v-if="(type === 'new' && applyInfo.status === 10) || (type === 'new' && applyInfo.status === '') ">暂 存</el-button>
      <el-button type="primary" @click="addEventForm()" v-else-if="applyInfo.approvalFlag">提 交</el-button>
      <el-button  @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { add, getApplyDetail, auditAndNextUser, stagingApply } from '@/api/compApplyPaper'
import { query } from '@/api/compPaper'
import moment from 'moment'
import ReviewProcess from '@/components/ReviewProcess.vue'
import approval from '@/mixins/approval'
export default {
  mixins: [approval],
  components: {
    ReviewProcess,
  },
  data() {
    return {
      show: false,
      type: '',
      loading: false,
      certificatesList: [],
      fileTypeList: [
        {
          value: '营业执照（复印件）',
          label: '营业执照（复印件）'
        },
        {
          value: '产证（复印件）',
          label: '产证（复印件）'
        },
        {
          value: '法人身份证（复印件）',
          label: '法人身份证（复印件）'
        },
        {
          value: '营业执照（原件）',
          label: '营业执照（原件）'
        },
        {
          value: '产证（原件）',
          label: '产证（原件）'
        },
        {
          value: '法人身份证（原件）',
          label: '法人身份证（原件）'
        },
        {
          value: '个人证件',
          label: '个人证件'
        },
        {
          value: '其他',
          label: '其他'
        },
      ],
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      applyInfo: {
        paperName: '',
        paperType: '',
        purpose: '',
        disableTime: '',
        status: '',
        remark: '',
        auditPerson: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      },
      pickeroptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 当天之后的时间可选
        },
        // selectableRange: '01:00:00 - 23:59:59'
        selectableRange: [new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() +
          ' - 23:59:59'
        ],
        // (time) {
        //   console.log(time)
        //   return '01:00:00 - 23:59:59'
        // }
      },
      // userInfoList: [],
      activeName: '',
      rules: {
        paperName: [{ required: true, message: '请选择证件', trigger: 'change' }],
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
        purpose: [{ required: true, message: '请输入用途', trigger: 'blur' }],
        disableTime: [{ required: true, message: '请选择失效时间', trigger: 'change' }]
      }
    }
  },
  watch: {
    'applyInfo.disableTime': {
      handler(newVal, oldVal) {
        if (newVal !== null && newVal !== undefined) {
          // 原来的数据一直为今天，和新时间比对
          oldVal = Date.now();
          let start = new Date(oldVal);
          let end = new Date(newVal);
          // 判断是否超过一天
          var dateDiff = end.getDate() - start.getDate();
          if (dateDiff >= 1) {
            this.pickeroptions.selectableRange = '00:00:00 - 23:59:59';
          } else {
            this.pickeroptions.selectableRange = new Date().getHours() + ':' + new Date().getMinutes() + ':' +
              new Date().getSeconds() +
              ' - 23:59:59'
          }
        }
      }
    }
  },
  props: {
    // certificatesList: {
    //   type: Array,
    //   default: () => []
    // }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    async handlePaperType(value) {
      const { result: { records } } = await query({ paperType: value })
      this.certificatesList = records
      this.applyInfo.paperName = ''
    },
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.applyInfo.remark = '同意'
      } else if (val === '3') {
        this.applyInfo.remark = '转办'
      } else {
        this.applyInfo.remark = ''
      }
    },
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
    // async queryList() {
    //         let res = await queryUserInfo({
    //             pageNum: 1,
    //             pageSize: 9999,
    //         })
    //         if (res.code === 0) {
    //             this.userInfoList = res.result.records
    //         }
    //     },
    showDetails(type, id, activeName) {
      console.log(id);
      this.type = type
      this.show = true
      this.activeName = activeName
      if (id) {
        this.getDetails(id)
      }
    },
    getDetails(id) {
      this.loading = true
      getApplyDetail({
        id
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.applyInfo = {
          ...result,
          status: result.approvalFlag === true ? '' : result.status,
          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
        }
        if (this.type === 'new' && this.applyInfo && this.applyInfo.auditPersonId && result.status === 10) {
          this.applyInfo.auditPersonId = ''
        }
        this.handleStatus(result.createUser)
      })
    },
    close() {
      this.show = false
      this.loading = false
      this.type = ''
      this.applyInfo = {
        paperName: '',
        paperType: '',
        purpose: '',
        disableTime: '',
        auditPerson: '',
        status: '',
        
        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
        eventId: ''
      }
    },
    addEventForm() {
      this.$refs.applyForm.validate((vaild) => {
        if (vaild) {
          if (this.type === 'new') {
            add({
              paperName: this.applyInfo.paperName,
              paperType: this.applyInfo.paperType,
              purpose: this.applyInfo.purpose,
              disableTime: moment(this.applyInfo.disableTime).format('YYYY-MM-DD HH:mm:ss'),
              auditPersonId: this.applyInfo.auditPersonId,
              eventId: this.applyInfo.eventId,
            }).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$message.success('申请已提交')
              this.$emit('addSuccess')
              this.close()
            })
          } else if (this.applyInfo.approvalFlag) {
            auditAndNextUser({
              id: this.applyInfo.id,
              status: this.applyInfo.status,
              remark: this.applyInfo.remark,
              lastUserFlag: this.applyInfo.lastUserFlag,
              nextAuditUserName: this.applyInfo.nextAuditUserName,
            }).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$message.success('审批成功！')
              this.$emit('addSuccess')
              this.close()
            })
          }
        }
      })
    },
    async addStagingForm() {
      this.$refs.applyForm.validate(async(vaild) => {
      if (vaild) {
          const { code, message } = await stagingApply({ 
              paperName: this.applyInfo.paperName,
              paperType: this.applyInfo.paperType,
              purpose: this.applyInfo.purpose,
              disableTime: moment(this.applyInfo.disableTime).format('YYYY-MM-DD HH:mm:ss'),
              auditPersonId: this.applyInfo.auditPersonId,
              eventId: this.applyInfo.eventId,
             })
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('暂存成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 450px;
  width: 30%;

  .el-dialog__body {
    max-height: 70vh;
    overflow-y: scroll;
  }
}
</style>
